"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var decentraland_ui_1 = require("decentraland-ui");

var ToastProvider = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(ToastProvider, _react_1$default$Pure);

  function ToastProvider() {
    var _this;

    _classCallCheck(this, ToastProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ToastProvider).apply(this, arguments));

    _this.getCloseHandler = function (id) {
      return function () {
        return _this.props.onClose(id);
      };
    };

    return _this;
  }

  _createClass(ToastProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          toasts = _this$props.toasts,
          position = _this$props.position;
      var ToastComponents = [];

      for (var id in toasts) {
        var toast = toasts[id];

        if (!toast) {
          throw new Error("Couldn't find a toast for id \"".concat(id, "\""));
        }

        ToastComponents.push(react_1.default.createElement(decentraland_ui_1.Toast, {
          key: id,
          type: toast.type,
          title: toast.title,
          body: toast.body,
          closable: toast.closable,
          timeout: toast.timeout,
          onClose: this.getCloseHandler(toast.id)
        }));
      }

      return react_1.default.createElement(react_1.default.Fragment, null, children, react_1.default.createElement(decentraland_ui_1.Toasts, {
        position: position
      }, ToastComponents));
    }
  }]);

  return ToastProvider;
}(react_1.default.PureComponent);

exports.default = ToastProvider;
ToastProvider.defaultProps = {
  children: null
};